/***************/
/**  IMPORTS  **/
/***************/

/***********************/
/**  AMPLIFY IMPORTS  **/
/***********************/

/****************************/
/**  LOCAL/ASSETS IMPORTS  **/
/****************************/
import { AddressStatsProvider } from "../../../utils/LocationsContext";
import StreetBlockPDF from "../StreetBlockPDF";
import {
      Document,
      Page,
      Text,
      View,
      StyleSheet,
    } from "@react-pdf/renderer";

/******************/
/**  PDF STYLES  **/
/******************/
const styles = StyleSheet.create({
    page: {
        backgroundColor: "white",
        display: 'flex',
        width: "100%",
        flexDirection: "row",
        padding: 50,
    },
    header: {
        paddingTop: 15,
        flexDirection: "column",
        display: "flex",
        marginBottom: 20,
    },
    row: {
        flexDirection: "row",
        display: "flex",
    },
    col: {
        flexDirection: "col",
        display: "flex",
        height: "3px",
    },
    streetname: {
        fontSize: '11px',
        color: "red",
        fontFamily: "Helvetica-Bold",
        paddingBottom: '2px',
        flexDirection: 'row',
    },
    cross: {
        fontFamily: "Helvetica",
        fontSize: '8px',
        flexDirection: 'row',
    },
    horizontalstreet: {
        flexDirection: "row",
        display: "flex",
        width: "1px",
        justifyContent: "space-between",
        marginTop: "-3px",
    },
    horizontalstreetname: {
        display: "flex", 
        flexDirection: "column", 
        color: "#205DBC", 
        fontSize: "7px", 
        fontStyle: "bold", 
        marginLeft: "-380px",
        width: "70px",
        width: "80px",
        marginTop: "-3px",
    },
    });

    /**
     * This component is responsible for creating the PDF of the tenant map
     * @returns A tenant map
     */
    const HaightPDF = ({street, groupedAddresses, highlightAvailableIsChecked, highlightTempClosedIsChecked, addresses, highlightBuildingForSale, allTotalsAreChecked }) => {

        const between = {"1915": "WILMOT ST", "1930": "WILMOT ST"};
        const parks = {"Before 67": "Residential", "101": "Residential","200": "Residential","300": "Residential","After 800": "Residential","801": "Residential","900": "Residential","After 901": "Residential","1001": "Residential", "Before 1080": "Residential","1100": "Residential","1101": "Buena Vista Park", "1200": "Residential","1201": "Buena Vista Park"};
        
        if (!groupedAddresses) {
            console.log("Grouped Addresses");
            return <Text>Loading...</Text>; // Or any other loading indicator
        }

        let totalPg1 = 0;

        for (const key in groupedAddresses) {
        const numericKey = parseInt(key, 10);
            if (numericKey >= 0 && numericKey <= 600) {
                const { odds = [], evens = [] } = groupedAddresses[key];
                let largerGroupCount = Math.max(odds.length, evens.length);
                if (largerGroupCount < 3) {
                    largerGroupCount = 3;
                }
                totalPg1 += largerGroupCount;
            }
        }

        let totalPg2 = 0;

        for (const key in groupedAddresses) {
        const numericKey = parseInt(key, 10);
            if (numericKey >= 700 && numericKey <= 1300) {
                const { odds = [], evens = [] } = groupedAddresses[key];
                let largerGroupCount = Math.max(odds.length, evens.length);
                if (largerGroupCount < 3) {
                    largerGroupCount = 3;
                }
                totalPg2 += largerGroupCount;
            }
        }

        let totalPg3 = 0;

        for (const key in groupedAddresses) {
        const numericKey = parseInt(key, 10);
            if (numericKey >= 1400 && numericKey <= 1800) {
                const { odds = [], evens = [] } = groupedAddresses[key];
                let largerGroupCount = Math.max(odds.length, evens.length);
                if (largerGroupCount < 3) {
                    largerGroupCount = 3;
                }
                totalPg3 += largerGroupCount;
            }
        }

        const allBlocksProps = {
            street: street, 
            between: between,
            parks: parks,
            highlightAvailableIsChecked,
            highlightTempClosedIsChecked
        };
        const pg1Props = {
            divisor: 7,
            maxTotalAddresses: totalPg1,
        };
        const pg2Props = {
            divisor: 7,
            maxTotalAddresses: totalPg2,
        };
        const pg3Props = {
            divisor: 5,
            maxTotalAddresses: totalPg3,
        };

        return (
            <Document>
                <Page size='A4' style={styles.page}>
                    <View style={styles.header}>
                        <Text style={{color: "#205DBC", fontSize: "12px", fontFamily: 'Times-Bold', width: "100px", display: "flex", flexDirection: "row", marginBottom: "12px"}}>
                            MAPRETAIL.NET
                        </Text>
                        <Text style={styles.streetname}>{street.toUpperCase()}</Text>
                        <Text style={styles.streetname}>TENANT MAP</Text>
                        <Text style={[styles.cross, {marginBottom: "15px"}]}>GOUGH TO STANYAN</Text>
                        <AddressStatsProvider highlightAvailableIsChecked={highlightAvailableIsChecked} highlightTempClosedIsChecked={highlightTempClosedIsChecked} addresses={addresses} highlightBuildingForSale={highlightBuildingForSale} allTotalsAreChecked={allTotalsAreChecked} />
                        <View style={{flexDirection: 'row', display: 'flex'}}>
                            <Text style={{fontSize:"7px", marginTop: "370px", width: "100px"}}>Disclaimer:  All information on this Map is provided without guarantee and all information should be independently verified. There may be errors or omissions in the information presented, and the creators of this web application make no representations or warranties regarding its accuracy. It is the user's sole responsibility to conduct their own independent research and not to rely on this map application in any way. Furthermore, by agreeing to use this web application, you acknowledge and agree that it is prohibited to sell, reproduce, or utilize this map for any purpose other than personal, non-commercial use without the express written consent of the owners. We are not liable for any loss or damages arising from the use of this application, and users may be held liable for unauthorized use. For all inquiries, please contact: mapretail.net@gmail.com .</Text>
                        </View>
                    </View>
                    <View style={{flexDirection: 'column', display: 'flex', width: "300px", paddingLeft:"365px", justifyContent: "center"}}>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>GOUGH STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg1Props}
                            addresses={groupedAddresses["0"]} 
                            building={"0"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>OCTAVIA STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg1Props}
                            addresses={groupedAddresses["100"]} 
                            building={"100"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>LAGUNA STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg1Props}
                            addresses={groupedAddresses["200"]} 
                            building={"200"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>BUCHANAN STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg1Props}
                            addresses={groupedAddresses["300"]} 
                            building={"300"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>WEBSTER STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg1Props}
                            addresses={groupedAddresses["400"]} 
                            building={"400"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>FILLMORE STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg1Props}
                            addresses={groupedAddresses["500"]} 
                            building={"500"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>STEINER STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg1Props}
                            addresses={groupedAddresses["600"]} 
                            building={"600"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>PIERCE STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                    </View>
                </Page>
                <Page size='A4' style={styles.page}>
                    <View style={styles.header}>
                        <Text style={{color: "#205DBC", fontSize: "12px", fontFamily: 'Times-Bold', width: "100px", display: "flex", flexDirection: "row", marginBottom: "12px"}}>
                            MAPRETAIL.NET
                        </Text>
                        <Text style={styles.streetname}>{street.toUpperCase()}</Text>
                        <Text style={styles.streetname}>TENANT MAP</Text>
                        <Text style={styles.cross}>GOUGH TO STANYAN</Text>
                        <View style={{flexDirection: 'row', display: 'flex'}}>
                            <Text style={{fontSize:"7px", marginTop: "420px", width: "100px"}}>Disclaimer:  All information on this Map is provided without guarantee and all information should be independently verified. There may be errors or omissions in the information presented, and the creators of this web application make no representations or warranties regarding its accuracy. It is the user's sole responsibility to conduct their own independent research and not to rely on this map application in any way. Furthermore, by agreeing to use this web application, you acknowledge and agree that it is prohibited to sell, reproduce, or utilize this map for any purpose other than personal, non-commercial use without the express written consent of the owners. We are not liable for any loss or damages arising from the use of this application, and users may be held liable for unauthorized use. For all inquiries, please contact: mapretail.net@gmail.com .</Text>
                        </View>
                    </View>
                    <View style={{flexDirection: 'column', display: 'flex', width: "300px", paddingLeft:"400px", justifyContent: "center"}}>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>PIERCE STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg2Props}
                            addresses={groupedAddresses["700"]} 
                            building={"700"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>SCOTT STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg2Props}
                            addresses={groupedAddresses["800"]} 
                            building={"800"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>DIVISADERO STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg2Props}
                            addresses={groupedAddresses["900"]} 
                            building={"900"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>BRODERICK STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg2Props}
                            addresses={groupedAddresses["1000"]} 
                            building={"1000"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>BAKER STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg2Props}
                            addresses={groupedAddresses["1100"]} 
                            building={"1100"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>LYON STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg2Props}
                            addresses={groupedAddresses["1200"]} 
                            building={"1200"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>CENTRAL AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg2Props}
                            addresses={groupedAddresses["1300"]} 
                            building={"1300"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>MASONIC AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                    </View>
                </Page>
                <Page size='A4' style={styles.page}>
                    <View style={styles.header}>
                        <Text style={{color: "#205DBC", fontSize: "12px", fontFamily: 'Times-Bold', width: "100px", display: "flex", flexDirection: "row", marginBottom: "12px"}}>
                            MAPRETAIL.NET
                        </Text>
                        <Text style={styles.streetname}>{street.toUpperCase()}</Text>
                        <Text style={styles.streetname}>TENANT MAP</Text>
                        <Text style={styles.cross}>GOUGH TO STANYAN</Text>
                        <View style={{flexDirection: 'row', display: 'flex'}}>
                            <Text style={{fontSize:"7px", marginTop: "420px", width: "100px"}}>Disclaimer:  All information on this Map is provided without guarantee and all information should be independently verified. There may be errors or omissions in the information presented, and the creators of this web application make no representations or warranties regarding its accuracy. It is the user's sole responsibility to conduct their own independent research and not to rely on this map application in any way. Furthermore, by agreeing to use this web application, you acknowledge and agree that it is prohibited to sell, reproduce, or utilize this map for any purpose other than personal, non-commercial use without the express written consent of the owners. We are not liable for any loss or damages arising from the use of this application, and users may be held liable for unauthorized use. For all inquiries, please contact: mapretail.net@gmail.com .</Text>
                        </View>
                    </View>
                    <View style={{flexDirection: 'column', display: 'flex', width: "300px", paddingLeft:"400px", justifyContent: "center"}}>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>MASONIC AVENUE</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg3Props}
                            addresses={groupedAddresses["1400"]} 
                            building={"1400"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>ASHBURY STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg3Props}
                            addresses={groupedAddresses["1500"]} 
                            building={"1500"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>CLAYTON STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg3Props}
                            addresses={groupedAddresses["1600"]} 
                            building={"1600"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>COLE STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg3Props}
                            addresses={groupedAddresses["1700"]} 
                            building={"1700"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text>SHRADER STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                        <StreetBlockPDF 
                            {...allBlocksProps}
                            {...pg3Props}
                            addresses={groupedAddresses["1800"]} 
                            building={"1800"}/>
                        <View style={styles.horizontalstreet}>
                            <View style={styles.horizontalstreetname}>
                                <Text style={{marginTop:"-4px"}}>STANYAN STREET</Text>
                            </View>
                            <View style={styles.col}>
                                <View style={{display: "flex", flexDirection: "row", height:'5px', backgroundColor: '#205DBC', width: "300px"}}></View>
                            </View>
                        </View>
                    </View>
                </Page>
            </Document>
        )
        
    }

    export default HaightPDF;